import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=9fd86718"
import script from "./PieChart.ts?vue&type=script&lang=ts&external"
export * from "./PieChart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports